import axios from 'axios'

const state = {
	data: null,
	isLoading: false,
	error: null,
}

export const mutationTypes = {
	getFiltersStart: '[filters] Get data start',
	getFiltersSuccess: '[filters] Get data success',
	getFiltersFailure: '[filters] Get data failure',
}

export const filtersActionTypes = {
	getFilters: '[filters] Get data',
}

const mutations = {
	[mutationTypes.getFiltersStart](state) {
		state.isLoading = true
	},
	[mutationTypes.getFiltersSuccess](state, payload) {
		state.isLoading = false
		state.data = payload
	},
	[mutationTypes.getFiltersFailure](state) {
		state.isLoading = false
	},
}

const actions = {
	[filtersActionTypes.getFilters](context, { apiUrl, filtersValue }) {
		return new Promise(resolve => {
			context.commit(mutationTypes.getFiltersStart)
			axios
				.get(apiUrl + filtersValue)
				.then(response => {
					context.commit(mutationTypes.getFiltersSuccess, response.data)
					resolve(response.data)
				})
				.catch(() => {
					context.commit(mutationTypes.getFiltersFailure)
				})
		})
	},
}

export default {
	state,
	actions,
	mutations,
}
